import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "../data/content";

const PILLARS = [
  { title: "Senior-led, always", text: "Every engagement is led personally by a senior consultant who has run organisations, not just studied them." },
  { title: "Specialists by design", text: "Supported by practitioners in strategy, operations, people and sector domains — drawn in as the work demands." },
  { title: "Rooted in India", text: "Three decades inside Indian institutions, family businesses, hospitals and campuses — pan-India, on the ground." },
];

const PHOTOS = [
  { id: "main", src: IMAGES.womenLeaders, alt: "The Synergy Next team" },
  { id: "secondary", src: IMAGES.womanConsultant, alt: "The Synergy Next team in the boardroom" },
];

const TeamCopy = () => (
  <div className="lg:col-span-5">
    <Reveal>
      <Eyebrow>Our Team</Eyebrow>
      <h2 className="f-display text-4xl sm:text-5xl lg:text-[3.6rem] text-[#0B2A5B] tracking-tight mt-4 leading-[1.1]">
        A senior consulting collective,{" "}
        <span className="italic text-[#1E5FE0]">not a pyramid.</span>
      </h2>
      <p className="mt-6 text-base text-slate-600 leading-relaxed">
        Our team brings together senior practitioners from industry,
        institutions and academia — people who have run organisations, not
        just studied them. Every engagement is led personally by a senior
        consultant and supported by specialists in strategy, operations,
        people and sector domains.
      </p>
    </Reveal>
    <div className="mt-10 space-y-6">
      {PILLARS.map((p, i) => (
        <Reveal key={p.title} delay={0.1 + i * 0.08} className="border-l-2 border-[#1E5FE0]/30 pl-5 hover:border-[#1E5FE0] transition-colors duration-500">
          <h3 className="f-display text-xl text-[#0B2A5B]">{p.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.text}</p>
        </Reveal>
      ))}
    </div>
  </div>
);

const TeamGallery = () => (
  <div className="lg:col-span-7 grid grid-cols-12 gap-4 lg:pt-10">
    {PHOTOS.map((ph, i) => (
      <Reveal key={ph.id} delay={i * 0.1} className="col-span-12 sm:col-span-6">
        <div className="relative rounded-2xl overflow-hidden aspect-[3/2] border border-[#0B2A5B]/10 shadow-[0_18px_40px_-28px_rgba(11,42,91,0.35)]">
          <img src={ph.src} alt={ph.alt} data-testid={`leadership-image-${ph.id}`} className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </Reveal>
    ))}
    <Reveal delay={0.15} className="col-span-12">
      <div className="relative rounded-2xl overflow-hidden bg-[#0B2A5B] p-6 lg:p-8 flex items-center gap-6">
        <span className="hidden sm:flex h-16 px-4 rounded-xl bg-white items-center justify-center shrink-0">
          <img src={IMAGES.logoMark} alt="" className="h-10 w-auto" />
        </span>
        <p className="f-display text-white text-lg lg:text-2xl leading-snug" data-testid="leadership-quote">
          &ldquo;We measure ourselves by where clients are years later.&rdquo;
        </p>
      </div>
    </Reveal>
  </div>
);

export const Leadership = () => (
  <section id="leadership" data-testid="leadership-section" className="py-24 lg:py-32 bg-white border-y border-[#0B2A5B]/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <TeamCopy />
        <TeamGallery />
      </div>
    </div>
  </section>
);
